import React from "react";
import { ReactComponent as BsBoxArrowRight } from "../../assets/Icons/Universal/BsBoxArrowRight.svg";
import "../../styles/ComponentsStyles/Universal/CustomTable.style.css";

const CustomTable = ({ headers, data, renderFooterElement }) => {
  return (
    <>
      <div className="custom-table-container">
        <table className="custom-table">
          <thead>
            <tr>
              {headers.map((header, index) => (
                <th key={index} className="table-header">
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={rowIndex} className="table-row">
                <td className="table-cell">
                  {row?.receiptId}
                  <br />
                  <span id="time">{row?.time}</span>
                </td>
                <td className="table-cell">
                  {row.amount} <br /> <span id="paymentMode">{row?.mode}</span>
                </td>
                <td className="table-cell">{row.purpose}</td>
                <td className="table-cell">
                  {row.profile} ({row?.class})<br />
                  <span id="profileId">{row?.profileId}</span>
                </td>
                <td className="table-cell">{row.signatory}</td>
                <td className="table-cell">
                  <button className="custom-button">
                    Receipt
                    <BsBoxArrowRight />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {renderFooterElement}
      {/* <div className="custom-table-footer">
        <div id="totalCount">Total Count: 236</div>
        <div id="totalAmount">
          Total Amount:{" "}
          <span style={{ color: "var(--tableColor)" }}>₹2,60,560</span>
        </div>
      </div> */}
    </>
  );
};

export default CustomTable;
